// True if `name` matches an existing entry case-insensitively, ignoring the
// entry with id `selfId` so an item can keep — or recase — its own name.
export function nameCollides(
  name: string,
  existing: readonly { id: string; name: string }[],
  selfId: string
): boolean {
  const target = name.trim().toLowerCase();
  return existing.some(
    (e) => e.id !== selfId && e.name.toLowerCase() === target
  );
}
